export default __webpack_public_path__ + "static/media/delete_icon.81526450.svg";